/**
 * A lake's price lists (CS-232) — the dated containers every price of that lake is versioned by, and
 * which the pricing grids are addressed through. Which one applies to a stay is resolved
 * chronologically by the backend: the latest list starting on or before the arrival date. Creating one
 * dated in the future is therefore how a price increase is prepared without touching the prices
 * current bookings are made at.
 *
 * Mirrors the API's CrmWaterPriceListDtos.
 */

export interface WaterPriceList {
  id: number;
  name: string;
  /** ISO date string (backend DateOnly), e.g. "2026-01-01". */
  startDate: string;
}

/** Create or rename/re-date one price list. Both writes carry the same two fields. */
export interface WaterPriceListCreateOrUpdate {
  name: string;
  /** ISO date string (backend DateOnly), e.g. "2026-01-01". */
  startDate: string;
}

/**
 * The `code` a rejected write can carry, from BadRequestException in CrmWaterPriceListService. Both
 * protect the backend's chronological resolution, and both need their own message — a generic "could
 * not save" would leave the user with no idea what to change.
 */
export const PRICE_LIST_ERROR_CODES = {
  /** Another price list of this lake already starts on that date, so which one wins would be arbitrary. */
  duplicateStartDate: 'duplicate-start-date',
  /** The change would leave the lake with no price list in effect, so it could not be priced at all. */
  noActivePriceList: 'no-active-price-list',
} as const;
